export var AccountInstallationMethod;
(function (AccountInstallationMethod) {
    AccountInstallationMethod["ACCOUNT_INSTALLATION_METHOD_UNSPECIFIED"] = "UNSPECIFIED";
    AccountInstallationMethod["ACCOUNT_INSTALLATION_METHOD_CLOUDFORMATION"] = "CLOUDFORMATION";
    AccountInstallationMethod["ACCOUNT_INSTALLATION_METHOD_TERRAFORM"] = "TERRAFORM";
    AccountInstallationMethod["ACCOUNT_INSTALLATION_METHOD_BASH_SCRIPT"] = "BASH_SCRIPT";
})(AccountInstallationMethod || (AccountInstallationMethod = {}));
